var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7802 14.7802C14.4871 15.0733 14.0129 15.0733 13.7194 14.7802L7.5007 8.56005L1.28058 14.7802C0.987475 15.0733 0.513254 15.0733 0.219826 14.7802C-0.0732752 14.4871 -0.0732752 14.0129 0.219826 13.7194L6.44136 7.5007L0.220763 1.28058C-0.0723377 0.987475 -0.0723377 0.513254 0.220763 0.219826C0.513864 -0.0732752 0.988084 -0.0732752 1.28151 0.219826L7.5007 6.44136L13.7208 0.221232C14.0139 -0.071869 14.4882 -0.071869 14.7816 0.221232C15.0747 0.514332 15.0747 0.988553 14.7816 1.28198L8.56005 7.5007L14.7802 13.7208C15.0755 14.0114 15.0755 14.4896 14.7802 14.7802Z",
    fill: "#B1B1B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6e1d9af9f983b3a850729ce7591f056a.svg";
export { ForwardRef as ReactComponent };